import React from 'react';
import PropTypes from 'prop-types';

const Asterisk = ({ color = '#8C949C' }) => (
    <svg
        width="18px"
        height="18px"
        viewBox="0 0 18 18"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs>
            <path
                d="M10.5613811,8.12721893 L13.5434783,8.02366864 C13.8154319,8.02366864 14.042838,8.11735607 14.2257033,8.30473373 C14.4085687,8.49211139 14.5,8.72879541 14.5,9.0147929 C14.5,9.28106642 14.4085687,9.51035407 14.2257033,9.70266272 C14.042838,9.89497138 13.8154319,9.99112426 13.5434783,9.99112426 L10.5332481,9.88757396 L12.0805627,12.5207101 C12.1274512,12.5996059 12.1602727,12.685897 12.1790281,12.7795858 C12.1977836,12.8732746 12.2071611,12.9595657 12.2071611,13.0384615 C12.2071611,13.2751491 12.1204186,13.4945749 11.9469309,13.6967456 C11.7734433,13.8989162 11.5413484,14 11.2506394,14 C11.0912183,14 10.9364884,13.9580872 10.786445,13.8742604 C10.6364016,13.7904335 10.519182,13.669626 10.4347826,13.5118343 L8.97186701,10.760355 L7.5370844,13.5118343 C7.452685,13.669626 7.33312098,13.7904335 7.17838875,13.8742604 C7.02365652,13.9580872 6.86658221,14 6.70716113,14 C6.4258298,14 6.19607932,13.8989162 6.01790281,13.6967456 C5.8397263,13.4945749 5.75063939,13.2751491 5.75063939,13.0384615 C5.75063939,12.8510839 5.79752724,12.6785018 5.89130435,12.5207101 L7.43861893,9.88757396 L4.45652174,9.99112426 C4.19394583,9.99112426 3.96888414,9.89497138 3.78132992,9.70266272 C3.5937757,9.51035407 3.5,9.28106642 3.5,9.0147929 C3.5,8.72879541 3.59143131,8.49211139 3.77429668,8.30473373 C3.95716204,8.11735607 4.18456812,8.02366864 4.45652174,8.02366864 L7.41048593,8.12721893 L5.86317136,5.49408284 C5.76939425,5.33629112 5.72250639,5.16863994 5.72250639,4.99112426 C5.72250639,4.73471272 5.8139377,4.50542507 5.99680307,4.30325444 C6.17966843,4.1010838 6.40707451,4 6.67902813,4 C6.84782693,4 7.00490123,4.04437825 7.15025575,4.13313609 C7.29561027,4.22189393 7.41986308,4.34516686 7.5230179,4.50295858 L8.97186701,7.32840237 L10.4488491,4.50295858 C10.5332485,4.33530488 10.6528125,4.21203195 10.8075448,4.13313609 C10.962277,4.05424024 11.1240401,4.00986198 11.2928389,4 C11.5647925,4 11.7898542,4.1010838 11.9680307,4.30325444 C12.1462072,4.50542507 12.2352941,4.73471272 12.2352941,4.99112426 C12.2352941,5.16863994 12.1930951,5.33629112 12.1086957,5.49408284 L10.5613811,8.12721893 Z"
                id="asterisk-path-1"
            />
        </defs>
        <g
            id="Svg-Icons/18px-(All-icons)/asterisk"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <mask id="mask-2" fill="white">
                <use xlinkHref="#asterisk-path-1" />
            </mask>
            <use id="*" fill={color} xlinkHref="#asterisk-path-1" />
        </g>
    </svg>
);

Asterisk.propTypes = {
    color: PropTypes.string,
};

export default Asterisk;
